class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.onBodyClick = this.handleBodyClick.bind(this);
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll('[data-cart-icon-bubble]');
  
    if (!cartLinks.length) return;
 
    cartLinks.forEach(cartLink => {
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
  
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }
  
  handleBodyClick(evt) {
    const target = evt.target; 
    if (target.closest('cart-drawer')) {
      this.close();
    }
  }

  connectedCallback() {
    this.backdropClose = this.querySelector('[data-backdrop-overlay]');
    this.backdropClose.addEventListener('click', this.onBodyClick);

    this.drawerClose = this.querySelector('[data-drawer-close]');
    this.drawerClose.addEventListener('click', this.onBodyClick);

    // Add cursor-following icon functionality
    this.handleCursorMove();
  }

  handleCursorMove() { 

    const cursorWrapper = this.querySelector('[data-cursor-hover]'); 

    gsap.set(cursorWrapper, { xPercent: 0, yPercent: 0 });                                                           

    const xTo = gsap.quickTo(cursorWrapper, 'x', { duration: 0.1, ease: 'power3' });
    const yTo = gsap.quickTo(cursorWrapper, 'y', { duration: 0.1, ease: 'power3' });

    this.backdropClose.addEventListener('mousemove', (e) => {
      gsap.to(cursorWrapper, { opacity: 1, scale: 1, duration: 0.1 });
      xTo(e.clientX); 
      yTo(e.clientY);
    });
    this.backdropClose.addEventListener('mouseleave', (e) => { 
      gsap.to(cursorWrapper, { scale: 0, duration: 0.1 }); 
    });
    this.backdropClose.addEventListener('mouseenter', (e) => {
      gsap.to(cursorWrapper, { scale: 1, duration: 0.1 });
    });
  }
  addEventListeners() {
      this.addEventListener('mouseenter', (e) => this.handleMouseEnter(e));
      this.addEventListener('mouseleave', (e) => this.handleMouseLeave(e));
  }


  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    if(document.querySelector('quick-view-drawer')) {
      document.querySelector('quick-view-drawer').classList.remove('open'); 
      document.body.classList.remove('overflow-hidden');
      document.body.removeAttribute("data-lenis-prevent");
    }

    this.cart_drawer = document.querySelector('cart-drawer');
    if (this.cart_drawer) {
      setTimeout(() => {
        this.cart_drawer.classList.add('open');
        document.body.classList.add('overflow-hidden');
      }, 200);
      document.body.setAttribute("data-lenis-prevent", "true");
    }

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.cart_drawer;
        const focusElement = this.cart_drawer.querySelector('[data-drawer-close]');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }

  close() { 
    this.cart_drawer.classList.remove('open');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.removeAttribute("data-lenis-prevent");
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    
    setTimeout(() => {
      this.open();
    },100); 
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
      {
        id: 'mobile-cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);


